/* eslint-disable no-prototype-builtins */
import { FilePreviewConfig } from './types';
import { VueConstructor } from 'vue';
import { useRender } from './hooks/useRender';
import 'common-module/src/util/markdown.css';
const varName = '$filePreview';
const { openPreviewDrawer, closePreviewDrawer, isRender } = useRender();

export {
  isRender,
  openPreviewDrawer,
  closePreviewDrawer
};

export default {
  install(Vue: VueConstructor, config?: FilePreviewConfig) {
    // useConfig(config);
    if (!Vue.prototype.hasOwnProperty(varName)) {
      // $FlowFixMe
      Object.defineProperty(Vue.prototype, varName, {
        get () {
          return {
            open: openPreviewDrawer,
            close: closePreviewDrawer,
            isRender
          };
        }
      });
    }
  }
};
